
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ReportUpdateLogs } from "./ReportUpdateLogs";

interface WorksheetUpdateLogsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  reportId: string;
}

export const WorksheetUpdateLogsDialog: React.FC<WorksheetUpdateLogsDialogProps> = ({
  open,
  onOpenChange,
  reportId,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[800px] max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>ประวัติการแก้ไข Worksheet</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <ReportUpdateLogs reportId={reportId} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
